import { ScrollToBottomButton } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

/**
 * The button floats `absolute` over its scroller, so each preview wraps it in a
 * `relative` framed box that stands in for a chat scroll region. Press any of
 * them to feel the shared Onyx offset-key press — a springy 1px press-DOWN; the
 * control stays round (no notch / block / ring, since the hex notch is for
 * rectangular surfaces only).
 */
function Scroller({ children }: { children: React.ReactNode }) {
  return (
    <div className="relative h-40 w-56 overflow-hidden rounded-lg border border-border bg-muted/30">
      <div className="space-y-2 p-3 text-xs text-muted-foreground">
        <p>…earlier messages scroll above…</p>
        <p>The float button sits bottom-center.</p>
        <p>Press it to feel the offset-key bounce.</p>
      </div>
      {children}
    </div>
  );
}

export function ScrollToBottomButtonDemo() {
  return (
    <Section
      id="scroll-to-bottom-button"
      title="ScrollToBottomButton"
      description="Floating 'jump to latest' affordance for chat scrollers. Round control in the Onyx 'offset key' language — it keeps its circle (the hex notch is for rectangular surfaces) and shares the springy 1px press-DOWN + bounce every button presses with. The fade+slide entrance (AnimatePresence) and the unread badge are preserved; the press is gated by motion + prefers-reduced-motion."
    >
      <VariantBlock label="Default">
        <Scroller>
          <ScrollToBottomButton onClick={() => {}} />
        </Scroller>
      </VariantBlock>

      <VariantBlock label="With unread count">
        <Scroller>
          <ScrollToBottomButton onClick={() => {}} unreadCount={4} />
        </Scroller>
        <Scroller>
          <ScrollToBottomButton onClick={() => {}} unreadCount={128} />
        </Scroller>
      </VariantBlock>

      <VariantBlock label="States">
        <Scroller>
          <ScrollToBottomButton onClick={() => {}} disabled />
        </Scroller>
        <Scroller>
          <ScrollToBottomButton onClick={() => {}} motion={false} />
        </Scroller>
      </VariantBlock>
    </Section>
  );
}
